<template>
  <!-- 监控配置 -->
    <basic-container>
      <el-form
        :model="searchForm"
        ref="searchFormRef"
        label-width="130px"
        label-suffix=":"
        v-show="searchBoxFlag"
      >
        <el-row :gutter="24">
         
          <el-col :span="6">
            <el-form-item label="监控名称" prop="monitorName">
              <el-input
                clearable
                v-model="searchForm.monitorName"
                placeholder="监控名称"
                maxlength="16"
              ></el-input>
            </el-form-item>
          </el-col>
  
          
          <el-col :span="18">
            <div style="float: right">
              <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
                搜索
              </el-button>
              <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <avue-crud
        :option="option"
        :table-loading="loading"
        :data="data"
        :page.sync="page"
        ref="crud"
        @on-load="onLoad"
        @current-change="currentChange"
        @size-change="sizeChange"
        @refresh-change="onLoad"
        @selection-change="selectionChange"
      >
        <template slot="menuRight">
          <searchFromShow
            :searchBoxFlag.sync="searchBoxFlag"
            :removeHeight="searchHeight"
            :option="option"
            reduceHeight="20"
            :refOption="$refs.crud"
          ></searchFromShow>
        </template>
        <template slot="menuLeft">
          <el-button type="primary" size="small" @click="addVideoConfigureForm"> 新 增</el-button>
        </template>
  
        <template slot-scope="scope" slot="menu">
          <el-button  type="text" size="small" @click="editConfig(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="deleteInfo(scope.row)">删除</el-button>
         
        </template>
      </avue-crud>
     
     
      <hr-dialog
        title="新增"
        :allowFull="false"
        width="60%"
        @close="closeAddOldManDialog"
        :visible.sync="videoConfigureFormVisible"
      >
        <template slot="body">
          <videoConfigureForm
            :model="formModel"
            :row="formRow"
            @success="recordSuccess"
            @cancle="recordCancle"
            v-if="videoConfigureFormVisible"
          ></videoConfigureForm>
        </template>
      </hr-dialog>
  
      
    </basic-container>
  </template>
  <script>


  import { monitorvideoPage,monitorvideoremove } from '@/api/call-system/video';
  import searchFromShow from '@/components/search-form-show/index';
  import { getDictionary } from '@/api/common.js';
  import { mapGetters } from 'vuex';
  import videoConfigureForm from './components/videoConfigureForm.vue';
  export default {
    components: { searchFromShow,videoConfigureForm  },
    data() {
      return {
       
        videoConfigureFormVisible: false,
        formModel: 'add',
      
        
        formRow:{},
        searchForm: {
          monitorName	:''
        },
  
      
        option: {
          selection: false,
          select: true,
          index: true,
          indexLabel: '#',
          page: true,
          height: 'auto',
          calcHeight: 'auto',
          align: 'left',
          menu: true,
          addBtn: false,
          editBtn: false,
          delBtn: false,
          border: true,
          column: [
            {
              label: '监控名称',
              prop: 'monitorName',
            },
  
            {
              label: '区域全称',
              prop: 'areaName',
            },
            {
              label: '设备编号',
              prop: 'deviceNo',
            },
            {
              label: '通道编号',
              prop: 'passageNo',
             
            },
            {
              label: '监控流地址',
              prop: 'url',
             
            },
            
          ],
        },
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        loading: false,
        searchBoxFlag: true,
        searchHeight: '',
        selectionList: [],
        recordIds: [],
        canteenList: [],
        warehouseList: [],
        selectionIds: '',
       
        sexList: [],
        politicList: [],
        politicalFeaturesList: [],
      };
    },
    created() {
      this.initData();
    },
    computed: {
      ...mapGetters(['permission']),
      permissionList() {
        return {
          viewBtn: this.vaildData(this.permission.oldman_view, false),
          addBtn: this.vaildData(this.permission.oldman_add, false),
          editBtn: this.vaildData(this.permission.oldman_edit, false),
          delBtn: this.vaildData(this.permission.oldman_delete, false),
        };
      },
    },
    mounted() {
      this.calcHeight();
      let self = this;
      self.$refs.crud.doLayout();
      window.onresize = () => {
        self.$refs.crud.doLayout();
      };
    },
    activated() {
      console.log('activated=======================');
      this.$refs.crud.doLayout();
    },
    methods: {
    
      addVideoConfigureForm(){
        this.formModel = 'add'
        this.videoConfigureFormVisible = true
        
      },
      editConfig(row){
        console.log("page",row)
        this.formModel = 'edit'
        this.formRow = row
        this.videoConfigureFormVisible = true
      },
  
      deleteInfo(row) {
        this.$confirm('是否确认删除该数据？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            monitorvideoremove({id:row.id}).then((re) => {
              this.$message.success('删除成功');
              this.onLoad();
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作',
            });
          });
      },
    
  
  
      recordCancle() {
        this.videoConfigureFormVisible= false
     
      },
      recordSuccess() {
        this.videoConfigureFormVisible= false
      
       
        this.onLoad();
      },
     
  
   
      searchRecord() {
        this.page.currentPage = 1;
       
        this.onLoad();
      },
      searchClear() {
        this.tool.clearObject(this.searchForm, 'nursinghomeId');
        this.searchForm.type = '0';
      },
  
      calcHeight() {
        this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
        this.option.height = this.bodyHeight - this.searchHeight - 279 - 20;
      },
      initData() {
       
            this.onLoad();
          
       
        getDictionary('sex').then((res) => {
          this.sexList = res.data;
        });
        getDictionary('nursinghome_political_features_type').then((res) => {
          this.politicalFeaturesList = res.data;
        });
      },
  
      onLoad() {
        if (this.searchForm.nursinghomeId != '') {
          this.loading = true;
  
          monitorvideoPage(
            Object.assign(
              {},
              { current: this.page.currentPage, size: this.page.pageSize },
              this.searchForm
            )
          )
            .then(({ data }) => {
              this.data = data.records;
              this.page.total = data.total;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      },
    },
  };
  </script>
  
  <style scoped>
  ::v-deep .avue-crud__right {
    display: flex;
  }
  /deep/ .el-drawer__body {
    overflow: scroll !important;
  }
  ::v-deep .avue-crud .el-form-item {
    display: block;
  }
  
  .money {
    text-align: right;
  }
  .txtOver {
    display: -webkit-box;
    overflow: hidden; /*超出隐藏*/
    text-overflow: ellipsis; /*隐藏后添加省略号*/
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  </style>
  <style>
  #alarmRule > div > div.el-dialog__body {
    height: calc(100% - 100px);
  }
  </style>
  